import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components";
import _ from "lodash";

type PatientInfo = {
  firstName: string;
  lastName: string;
  email: string;
};
interface PatientDataProps {
  patientInfo: PatientInfo;
  setPatientInfo: (data: PatientInfo) => void;
}

const PatientData = ({ patientInfo, setPatientInfo }: PatientDataProps) => {
  const { t } = useTranslation("common");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const nameRegex = /^[A-Za-z'’\- ]{1,40}$/;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]{2,}$/;

  const handleInput = (e: any) => {
    const value = e.target.value;
    if (e.target.name === "firstName") {
      setPatientInfo({ ...patientInfo, firstName: value });
      if (!nameRegex.test(value) && value !== "") {
        setFirstNameError(t("form_errors.valid_name"));
      } else {
        setFirstNameError("");
      }
    } else if (e.target.name === "lastName") {
      setPatientInfo({ ...patientInfo, lastName: value });
      if (!nameRegex.test(value) && value !== "") {
        setLastNameError(t("form_errors.valid_name"));
      } else {
        setLastNameError("");
      }
    } else if (e.target.name === "email") {
      setPatientInfo({ ...patientInfo, email: value });
      if (!emailRegex.test(value) && value !== "") {
        setEmailError(t("form_errors.valid_email"));
      } else {
        setEmailError("");
      }
    }
  };

  return (
    <div className="patient-data">
      <div className="patient-data_name">
        <Input
          name="firstName"
          value={patientInfo.firstName}
          placeholder={"First Name"}
          label={"First Name"}
          extraClass="patient-data_first-input"
          error={firstNameError}
          onChange={handleInput}
        />
        <Input
          name="lastName"
          value={patientInfo.lastName}
          placeholder={"Last Name"}
          label={"Last Name"}
          error={lastNameError}
          onChange={handleInput}
        />
      </div>
      <Input
        name="email"
        placeholder={"email@gmail.com"}
        label={"Your email:"}
        error={emailError}
        onChange={_.debounce((e: any) => handleInput(e), 1000)}
      />
    </div>
  );
};

export default PatientData;
